import { ColumnDef } from "@tanstack/react-table";
import { TableRenderUtils } from "../../components/Table/TableRenderUtils";
import { TrackReleaseRight } from "../../api/useRightsApi";
import { InputCheckbox } from "../../components/InputCheckbox";
import React from "react";

export function rightsColumnsDefinition(
  t: any
): Array<ColumnDef<TrackReleaseRight, any>> {
  return [
    {
      id: "select",
      size: 10,
      enableSorting: false,
      header: ({ table }) =>
        TableRenderUtils.renderBaseContent(
          <InputCheckbox
            checked={table.getIsAllRowsSelected()}
            onChange={(value, e) => {
              table.getToggleAllRowsSelectedHandler()(e);
            }}
          />
        ),
      cell: ({ row }) => (
        <InputCheckbox
          {...{
            checked: row.getIsSelected(),
            disabled: !row.getCanSelect(),
            indeterminate: row.getIsSomeSelected(),
            onChange: row.getToggleSelectedHandler()
          }}
        />
      )
    },
    {
      id: "ReleaseID",
      header: `${t("rights.release_id")}`,
      size: 10,
      enableSorting: false,
      accessorFn: (value) => value.release_id,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "Title",
      header: `${t("name")}`,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.display_title,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "Artist",
      header: `${t("artist")}`,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.display_artist_name,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "Authors",
      header: `${t("authors")}`,
      size: 300,
      enableSorting: false,
      accessorFn: (value) => value.authors_names,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(
          value.getValue()?.join(", ") ?? "—",
          { className: "text-sm" }
        );
      }
    },
    {
      id: "CodeISRC",
      header: `${t("isrc")}`,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.code_isrc,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "ExternalIDs",
      header: `${t("external_ids")}`,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.external_id,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "Share",
      header: () => <div className={"w-100 text-right"}>{t("share")}</div>,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.share,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm text-right"
        });
      }
    },
    {
      id: "IssueDate",
      header: `${t("issue_date")}`,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.issue_date,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "ExpireDate",
      header: `${t("expire_date")}`,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.expire_date,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "Contractor",
      header: `${t("contractor")}`,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.work_contractor,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    }
  ];
}
